import { render } from "./automate-responses.vue?vue&type=template&id=60736e26"
import script from "./automate-responses.vue?vue&type=script&lang=js"
export * from "./automate-responses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__